import { useEffect } from "react";
const useOnPageLeave = (action: any) => {
  useEffect(() => {
    return () => action();
  }, []);
};

export default useOnPageLeave;
